var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 21.3333L11.4467 15.2186C12.488 14.1776 14.176 14.1776 15.2174 15.2186L21.332 21.3333M18.6654 18.6666L20.78 16.5519C21.8214 15.5109 23.5094 15.5109 24.5507 16.5519L26.6654 18.6666M18.6654 10.6666H18.6787M7.9987 26.6666H23.9987C25.4705 26.6666 26.6654 25.4717 26.6654 23.9999V7.99992C26.6654 6.52815 25.4705 5.33325 23.9987 5.33325H7.9987C6.52692 5.33325 5.33203 6.52815 5.33203 7.99992V23.9999C5.33203 25.4717 6.52692 26.6666 7.9987 26.6666L5.33203 21.3333",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceImage);
export default __webpack_public_path__ + "static/media/resource-image.ca1edea04346883c70abfccbccfb02ef.svg";
export { ForwardRef as ReactComponent };